// Util to check if browser has local/session storage capabilities. Adds a
// temporary test object to the storage.
// `type` should be either `localStorage` or `sessionStorage`
var hasStorage = function hasStorage(type) {
  try {
    var testItem = '_STORAGE-TEST_';
    window[type].setItem(testItem, testItem);
    window[type].removeItem(testItem);
    return true;
  } catch (error) {
    return false;
  }
};

export default hasStorage;